export const DEFAULT_ROUTE_PATH = "/tel-aviv-university/MBA/Management";

export const COURSE_WEEKS_BY_PATH = {
  "/tel-aviv-university/MBA/Management": "7 שבועות",
  "/tel-aviv-university/BA/Management": "14 שבועות",
};

function pathKey(rawPath) {
  return String(rawPath || "").replace(/\/+$/, "") || "/";
}

export function courseWeeksForPath(...candidates) {
  for (const raw of candidates) {
    const key = pathKey(raw);
    if (COURSE_WEEKS_BY_PATH[key]) return COURSE_WEEKS_BY_PATH[key];
    const lower = key.toLowerCase();
    if (lower.includes("/mba/")) return "7 שבועות";
    if (lower.includes("/ba/")) return "14 שבועות";
  }
  return DEFAULT_TEXTS.courseWeeks;
}

export function isMbaManagementPath(...candidates) {
  for (const raw of candidates) {
    const key = pathKey(raw);
    const lower = key.toLowerCase();
    if (key === "/tel-aviv-university/MBA/Management" || lower.includes("/mba/")) return true;
  }
  return false;
}

export const MBA_COURSE_IDENTITY = {
  name: "פיתוח מנהיגות",
  number: "12433567",
  semester: "סמסטר א׳",
  year: "תשפ״ז 2026/2027",
  whenLabel: "מתי",
  day: "יום ג׳",
  hours: "18:45–21:30",
  dates: "07/12/2026 – 24/01/2027",
  whereLabel: "איפה",
  building: "לורי לוקיי",
  room: "חדר 004",
  note: "חצי סמסטריאלי · מחצית שנייה",
};

export const MBA_COURSE_TOOLS = {
  purposeNot: "המטרה היא לא ללמוד על מנהיגות",
  purposeYes: "המטרה היא לצאת מהקורס מנהיגים טובים יותר = פיתוח מנהיגות",
  lead: "בקורס תרכשו כלים פרקטיים ומעשיים, שתוכלו ליישם כבר מהיום הראשון",
  items: [
    "לקבל החלטות טובות יותר גם בתנאי אי־ודאות.",
    "להתמודד עם דילמות, משברים ואתגרים — צפויים ובלתי צפויים.",
    "להוביל אנשים, לרתום אותם ולהשפיע עליהם.",
    "להתמודד טוב יותר עם מצבי לחץ ומורכבות.",
    "להפוך ממנהל שמנהל משימות — למנהיג שמייצר השפעה.",
  ],
  punch: "המבחן האמיתי של מנהיגות הוא לא כשקל — אלא כשקשה",
};

export const MBA_FEEDBACK = [
  [
    "אחד הקורסים הכי מעניינים ואפקטיבים שהיו לי בתואר. מהרגע שנרשמתי לMBA חיכיתי לקורס כזה, פרקטי, מתמקד ביכולות בינאישיות ומעצים אותנו הסטודנטים.",
    "ד\"ר משה קטן מדהים, פתוח, קשוב, מנחה את הקבוצה ורוקם קשרים. כבר בשיעור הראשון זכר את השמות של כולנו, והיה לו חשוב לתת לנו להתבטא ולשתף חוויות אישיות. חבל לי שאין יותר קורסים כאלו בתואר.",
    "הרגשתי שהקורס הזה תרם לי באופן אישי, חידד אצלי יכולות והבנה שנתן לי דגשים על מה לעבוד על מנת לפתח את יכולות המנהיגות שלי.",
    "שתי העבודות בקורס — הן עבודת הצוות והן העבודה האישית — נעשו במהלך הקורס, תוך כדי הלמידה שלנו. הדבר הקל עלינו מאד מבחינת ניהול זמנים וגם חיבר אותנו ישירות לחומר הנלמד באותו השבוע, והביא אותנו ליישם את הלמידה גם במחקר חיצוני (העבודה הקבוצתית) וגם בניתוח פנימי על עצמנו (העבודה האישית).",
  ],
  [
    "הקורס הזה היה ממש מיוחד ושונה משאר הקורסים שאי פעם לקחתי. משה קטן לקח אותנו לתהליך מסע פיתוח מנהיגות אישי וחלק איתנו מהניסיון הרב שלו ומעולם המחקר העדכני.",
    "הייתה הרגשה שמשה לא רק בא ללמד חומר אלא באמת דואג שכל סטודנט וסטודנט יעבור תהליך התפתחות במהלך הקורס. משה הטמיע כלים שונים אשר עזרו לנו בתהליך הזה — הוראה כריזמטית ומקצועית, דיונים מרתקים ומעשירים בכיתה, משימות ייחודיות (קיבלנו משימה לקבוע ראיון עם מנכ\"ל של ארגון לבחירה).",
    "אני מרגיש שלמדתי המון מהקורס הזה ובאמת רכשתי כלים פרקטיים שיסייעו לי במקום העבודה שלי ובחיים בכלל.",
    "בנוגע למשה קטן בתור מרצה — הורגש שגם משה ממש נהנה להעביר את הקורס וגם שיש לו ידע עשיר מאוד אותו הוא רכש גם בניסיון העסקי וגם המחקרי. העובדה שמשה הגיע מעולם העסקים תרם מאוד לקורס כי הוא תמיד סיפק דוגמאות מחייו המקצועיים אשר המחישו תיאוריות שונות וזה באמת היה מידע זהב.",
    "בנוסף לכך, משה יצר אווירה מאוד נוחה וידידותית בכיתה ועודד כל סטודנט וסטודנטית להשתתף. בזכות האווירה הזו ומשימות הקבוצתיות מאוד התגבשנו ככיתה. לסיכום, אחד הקורסים הכי טובים שלקחתי!",
  ],
  [
    "אחד הקורסים המעניינים והמועילים שהיו לי בתואר.",
    "המרצה מעולה ונגיש, ועוזר להשלים את החומר למי שהיה במילואים. יש אפליקציה שמלווה את הקורס ומאוד ישים לעשות את המטלות דרכה.",
  ],
  [
    "הקורס הזה הוא מושלם, סדנה שמביאה כלים לניהול. לפי דעתי הקורס צריך להיות חובה עבור כל הסטודנטים לניהול.",
    "המרצה משה קטן מעביר את הסדנה בצורה מושלמת, הקורס הכי טוב בתואר — מומלץ לכולם",
  ],
  [
    "הקורס בפיתוח מנהיגות היה חוויה מעניינת ומיוחדת, המתאימה גם למנהלים בתחילת דרכם וגם למנהלים מנוסים.",
    "ההערכה המרכזית שכל אחד יכול להיות מנהיג ושמנהיגות היא כישור שניתן לפתח, הייתה החידוש המשמעותי ביותר שלקחתי מהקורס. דרכי ההוראה שילבו תיאוריה ופרקטיקה באופן שתורם להבנה עמוקה וליישום מעשי של החומר.",
    "ד״ר משה הוא מרצה נעים הליכות ומעביר את הקורס בצורה שונה ומיוחדת בשונה מקורסים רגילים המועברים במסגרת אקדמית. לסיכום קורס מיוחד ומרענן, מומלץ לכל סטודנט במנהל עסקים",
  ],
  [
    "הקורס הכי טוב שעשיתי בתואר. מרתק, מעשיר ונותן כלים פרקטיים לשימוש ביומיום שלנו — גם כמנהלים וגם בחיים האישיים.",
    "אהבתי מאוד שהמשימות ניתנו בשלבים עם התקדמות הקורס. זה סייע להפנים את הנושאים שדיברנו עליהם. אהבתי מאוד את ההשתתפות המפרה של הסטודנטים בכיתה ואת ההתייחסות ה\"מרימה\" של משה.",
    "היחס לסטודנטים היה מדהים וניתנה גמישות מאוד גדולה בכל סוגיה שהופנתה אליו. משה הוא בן אדם מעורר השראה ומדהים לראות את השליחות שלו ואת המסירות שלו בהעברת הכלים שהוא מאמין בהם הלאה.",
  ],
  [
    "המרצה היה מרתק, שילב את הנושאים התיאורטיים בצורה מאוד מעניינת. יצאתי מהקורס עם כלים פרקטיים לחיים.",
    "הקורס היה מאורגן וידוע מראש מה אנחנו צריכים לבצע בין כל מפגש ומפגש.",
  ],
  [
    "משה מרצה מדהים! הוא מגיע לתחום עם כל כך הרבה אמונה בקידום הסטודנטים.",
    "היה כיף לקחת חלק במסע הזה. הקורס הכי מומלץ הסמסטר!",
  ],
  [
    "קורס מאוד מעניין ושונה באופי שמועבר בו. סגל אקדמי מדהים עם יחס מצוין לסטודנטים.",
    "אני אישית נהניתי מהקורס ויצאתי עם המון מסקנות ונקודות עבודה. העבודות היו הוגנות ורלוונטיות. סה״כ חוויה חיובית.",
  ],
  [
    "פעם ראשונה שאני מרגישה בקורס כי הוא לטובת ההתפתחות האישית שלי לא פחות מהמקצועית. אני מרגישה שזאת לחלוטין מתנה שנתתי לעצמי לקחת את הקורס הזה.",
    "ניכר כי משה השקיע רבות בתוכן הנלמד וכי הוא בעיקר רוצה שניקח ממנו דברים פרקטיים שישפיעו על העתיד שלנו כמנהלים ובכלל.",
  ],
  "הקורס היה מעניין, גורם לחשוב ולפעול. אני חושבת שזה צריך להיות קורס חובה",
  [
    "זה הקורס היחידי בתואר (עד כה) שלקחתי שבאמת לימד אותי דברים בפרקטיקה ולא רק בתיאוריה.",
    "ההרצאות היו פעילות מאוד, ואינפורמטיביות, עם דוגמאות מהחיים האמיתיים וסיטואציות אמיתיות ואיך אפשר וצריך לפעול בכל סיטואציה.",
  ],
  [
    "העבודה בקבוצות מאוד תרמה לראות זווית אחרת של חשיבה והתמודדות. השיח והדיון הפתוח בכיתה גרמו לחוויה נעימה ושיתוף מלמד מחיי היום יום.",
    "המשימות האישיות מיקדו מאוד את ההתבוננות על היום יום ואיך אנחנו מצליחים להתפתח ולא להישאר במקום, גם במעשים הפשוטים ביותר. החזרה לשיעור וה״אימון\" במקום לאחר ההפסקה מאוד השאירו בפוקוס.",
    "באופן אישי, הקורס הוא אחד הקורסים החשובים ביותר שהיו לי בתואר. החומר הנלמד פוגש אותי כמעט בכל סיטואציה בעבודה ובבית. והיום, בזכות הקורס יש לי כלים טובים יותר להתמודדות.",
    "בנוסף, חמש הדקות שמקדישים בכל יום מפקסות אותי ו״מכריחות\" אותי לשים לעצמי יעדים, מה ששוב עוזר לי להתפתח ולא להישאר במקום. תודה!!",
  ],
  [
    "אחד הקורסים הכי משמעותיים שיצא לי ללמוד. משה אדם ומנהיג מיוחד שלגמרי השפיע עלי ולמדתי ממנו הרבה.",
    "עברתי תהליך עם הקורס הזה לגמרי ואני חושב שהקורס הזה ישאר איתי לתמיד. תודה משה",
  ],
  [
    "מטלות אשר מיישמות את החומר הנלמד, הצגת פרויקט אישי וקבוצתי מול הכיתה, נושאי לימוד מעניינים (פיתוח אישי וקולקטיבי) — בעיניי זה אחד מהקורסים הכי פרקטיים שאפשר לקחת לתחום הניהול!",
    "בנוסף, משה זמין לכל שאלה ומדבר מאוד בגובה העיניים. למרות שהיינו קבוצה גדולה, היחס הרגיש אישי והייתה התחשבות בכל נושא.",
  ],
  [
    "קורס מאוד מעניין ופרקטי. משה מרצה מדהים!!! תמיד רצה לעזור וללמד.",
    "משה לימד בצורה מדהימה, הוא נתן כלים אמיתיים ולימד דברים שבאמת יכולים לתרום לנו. הרגשתי שזה גם העצים אותי כבן אדם ופוטנציאלית כמנהלת.",
    "מעבר על החוזקות שלנו מאוד תרם לי ועזר לי להבין במה אני חזקה ולמה זה חשוב להכיר את זה. גם לשמוע ממנכ״לים זה מעניין ומלמד מאוד, וגם בכללי ההרצאות היו מעניינות ומלמדות.",
  ],
  [
    "מבחינתי היה מושלם.",
    "הייתי רוצה רק שהקורס יהיה ארוך יותר כדי שילווה אותנו לתקופה ארוכה יותר, מה שיסייע לנו להפנים וליישם טוב יותר את הכלים שלמדנו.",
  ],
  "היה קורס מצוין, לא ציפיתי לעבור קורס כזה באקדמיה, אין נקודות לשיפור. תודה רבה!",
].map((text, index) => ({
  key: `mba-feedback-${index + 1}`,
  paragraphs: Array.isArray(text) ? text : [text],
}));

export const MBA_FEEDBACK_TITLE = "מה הסטודנטים כותבים";

export const DEFAULT_TEXTS = {
  philosophyTitle: "אנחנו מאמינים",
  philosophyText:
    "שכל אחד יכול להיות מנהיג ויתרה מכך כל אחד צריך להיות מנהיג בכל תפקיד - בבית, בעבודה, עם חברים...",
  missionTitle: "היעוד שלנו:",
  missionText:
    "להנגיש כלים פרקטיים ואיכותיים לפיתוח מנהיגות, כדי שכל אדם יוכל ליישם אותם בחיי היומיום בעבודה, במשפחה ובקהילה ולהפוך למנהיג שמפתח אחרים סביבו.",
  visionTitle: "החזון שלנו:",
  visionText:
    "סביבה שבה יותר ויותר אנשים מצוידים בכלים ובמיומנויות מנהיגותיות, המאפשרים להם להיות בני זוג טובים יותר, הורים טובים יותר, מנהלים טובים יותר ואנשים טובים יותר ובכך לטפח חברה חסונה, חכמה, אנושית וחזקה יותר, בכפר, בעיר ובמדינה",
  offerTitle: "🎯 מה אנחנו מציעים?",
  offer1Title: "פיתוח המנהיג שבך",
  offer1Text:
    "תהליך אישי של מודעות עצמית, זיהוי עוצמות ומינוף הייחודיות שלך כמנהל לא רק ללמוד על מנהיגות, אלא לפתח אותה",
  offer2Title: "מנהיגות קולקטיבית",
  offer2Text:
    "הבנה איך מפתחים מנהיגות בצוות ובארגון, דרך תהליכים פורמליים ובלתי פורמליים שמחזקים את כולם לא רק את היחיד",
  offer3Title: "יישום בשטח",
  offer3Text:
    "תיאוריה שפוגשת ארגון אמיתי: ניתוח תהליך פיתוח מנהיגות בשטח, וכלים פרקטיים שאפשר לקחת חזרה לניהול היומיומי",
  courseTitle: "על הקורס",
  courseWeeks: "14 שבועות",
  courseQuote: "רוב המשאבים אפשר לקנות בכסף. מנהיגות אי אפשר לקנות. מנהיגות צריך לפתח.",
  courseQuoteCite: "Kets de Vries & Korotov",
  courseLead:
    "מנהיגות ופיתוח מנהיגות נמצאים בחזית העולם העסקי, המאופיין בשינויים מהירים ובמורכבות הולכת וגוברת. ארגונים משקיעים בזה משאבים רבים, כי מנהיגות נתפסת כגורם מרכזי להשגת יעדים במציאות של חוסר ודאות. היא מאפשרת יתרון יחסי ובידול.",
  experienceTitle: "🏆 הניסיון שלנו",
  experienceText:
    "הובלנו שישה קורסים בפיתוח מנהיגות (מעל 200 סטודנטים) בפקולטה לניהול באוניברסיטת תל אביב, במסלולי התואר הראשון והשני. הקורס קיבל הכרה מתמשכת וזכה בפעם השלישית ברציפות בתעודת הצטיינות של הדיקאן על המצוינות בהוראה וחדשנות.",
  videosTitle: "הבוגרים שלנו מספרים",
  feedback1:
    '"הקורס הכי טוב שעשיתי בתואר. מרתק, מעשיר ונותן כלים פרקטיים לשימוש ביומיום שלנו - גם כמנהלים וגם בחיים האישיים"',
  feedback2:
    '"אחד הקורסים הכי משמעותיים שיצא לי ללמוד, עברתי תהליך עם הקורס הזה לגמרי ואני חושב שהקורס הזה ישאר איתי לתמיד."',
  feedback3:
    '"זה הקורס היחידי בתואר (עד כה) שלקחתי שבאמת לימד אותי דברים בפרקטיקה ולא רק בתיאוריה. ההרצאות היו פעילות מאוד, ואינפורמטיביות, עם דוגמאות מהחיים האמיתיים וסיטואציות אמיתיות ואיך אפשר וצריך לפעול בכל סיטואציה."',
  contactTitle: "רוצים לדבר איתנו?",
  instructorName: 'ד"ר משה קטן',
  instructorBio1:
    "אחרי שביצע שורה של תפקידים בכירים והנהיג צוותים גדולים בחברות בינלאומיות הפועלות בישראל כמו: קרלסברג, קוקה קולה ושטראוס עלית, דר' קטן נמנה היום עם מס' מצומצם של מומחים לפיתוח מנהיגות עסקית מעשית. זאת באמצעות גילוי ה-C.O.D לפיתוח מנהיגות במסגרת לימודי הדוקטורט שלו ב-University of Poznan. בנוסף הוא Chair ב-Vistage ומוביל קבוצת מנכ״לים בישראל.",
  instructorBio2:
    "שיטת ה- C.O.D התגלתה במהלך המחקר המעמיק שביצע עם מנהלים בכירים בחברות גלובליות, התהליך מאפשר כיום לאירגונים רבים לשפר משמעותית את תפוקות הארגון ולהתמודד מול שינויים מתכוננים ושינויים בלתי צפויים.",
};
